import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CabinetsService } from '../../data/cabinets.service';
import { Cabinet } from '../../data/cabinet';
import { MiscSnackBarService } from 'projects/core/src/lib/misc/view/snackbar/misc-snackbar.service';

@Component({
  selector: 'app-punch-list-dialog',
  templateUrl: './punch-list-dialog.component.html',
  styleUrls: ['./punch-list-dialog.component.scss']
})
export class PunchListDialogComponent implements OnInit {
  cabinets: Cabinet[] = [];
  loading = true;
  saving = false;

  @ViewChild('scrollableItems')
  private scrollableItemsRef?: ElementRef<HTMLDivElement>;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: { projectId: number },
    private dialogRef: MatDialogRef<PunchListDialogComponent>,
    private cabinetsService: CabinetsService,
    private miscSnackBarService: MiscSnackBarService
  ) {}

  ngOnInit(): void {
    this.loadIncompleteCabinets();
  }

  loadIncompleteCabinets() {
    this.cabinetsService.getIncompleteQCCabinets(this.data.projectId).subscribe(
      cabinets => {
        this.cabinets = cabinets;
        this.loading = false;
      },
      error => {
        this.loading = false;
        this.miscSnackBarService.openErrorSnackBar('Failed to load cabinets');
      }
    );
  }

  save() {
    this.saving = true;
    const cabinetNames = this.cabinets.map(cab => cab.cabinetName);

    this.cabinetsService.createPunchItems(this.data.projectId, cabinetNames).subscribe(
      () => {
        this.saving = false;
        this.miscSnackBarService.openSuccessSnackBar('Success!');
        this.dialogRef.close('success');
      },
      error => {
        this.saving = false;
        this.miscSnackBarService.openErrorSnackBar('Error!');
      }
    );
  }

  cancel() {
    this.dialogRef.close();
  }

  trackByIndex(index: number): number {
    return index;
  }

  addNewItem() {
    this.cabinets.push({
      id: null,
      cabinetName: '',
      description: '',
      createdManually: true
    } as Cabinet);

    setTimeout(() => this.scrollToBottom(), 0);
  }

  private scrollToBottom() {
    const el = this.scrollableItemsRef?.nativeElement;
    if (el) {
      try {
        el.scrollTo({ top: el.scrollHeight, behavior: 'smooth' });
      } catch {
        el.scrollTop = el.scrollHeight;
      }
    }
  }

  removeItem(index: number) {
    if (this.cabinets.length > 1) {
      this.cabinets.splice(index, 1);
    }
  }
}
